import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import { ConfigurationAssayResponse, ConfigurationAssaySnomedCTCodeResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { Validator } from 'vee-validate'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'
import { commonSubportionTypeService } from '@/api/services/common/subportion-type/common-subportion-type.service'
import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { configurationAssaygroupService } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.service'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

@Component
export default class ConfigurationAssaysModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly assay!: Partial<ConfigurationAssayResponse>

    @Inject() externalValidator!: Validator

    get ownAssay(): boolean {
        return this.assay.snomedCTCode?.own ?? true
    }

    get updateMode(): boolean {
        return !!this.assay?.id
    }

    constructor() {
        super()
        this.$validator = this.externalValidator
    }

    async getSubportionTypes(): Promise<CommonSubportionTypeResponse[]> {
        const response = await this.$_toCallUnique(commonSubportionTypeService.getSubportionTypes())
        if (response) {
            return response.filter(subportion => subportion.sptActive)
        }
        return []
    }

    async getAssaygroups(): Promise<ConfigurationAssaygroupResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationAssaygroupService.paginator(undefined, params))
        return response?.content ?? []
    }

    getSnomedCTCodes(): Promise<ConfigurationAssaySnomedCTCodeResponse[]> {
        return Promise.resolve([]) // TODO: backend implementation pending
    }
}
